module.exports = __webpack_public_path__ + "img/pauli-y-root-dagger-31.c8fe7bb3.svg";